import { inject, Injectable } from '@angular/core';
import { first, map, Observable } from 'rxjs';
import { GungCompanyService } from '../gung-company/gung-company.service';

@Injectable({
  providedIn: 'root'
})
export class ProductListSettingsService {
  protected gungCompanyService = inject(GungCompanyService);

  hideUndefinedFilters = false;

  topFilter?: boolean;
  batchSizes?: number[];
  displayProductsOnVariantLevel?: boolean;
  fetchProductsExpanded?: boolean;
  searchDisabled?: boolean;
  assortmentBannerEnabled?: boolean;
  keepFilterOpen?: boolean;
  infiniteScroll?: boolean;
  showProductListInArticlesView?: boolean;

  constructor() {
    this.applyCompanyProductListConfig().subscribe();
  }

  protected applyCompanyProductListConfig(): Observable<void> {
    return this.gungCompanyService.getPublicGungCompany().pipe(
      first(),
      map(company => {
        const productListConfig = company?.extra?.layout?.productList;
        if (!productListConfig) {
          return;
        }
        if (productListConfig.hideUndefinedFilters != null) {
          this.hideUndefinedFilters = productListConfig.hideUndefinedFilters;
        }
        if (productListConfig.topFilter != null) {
          this.topFilter = productListConfig.topFilter;
        }
        if (productListConfig.batchSizes != null) {
          this.batchSizes = productListConfig.batchSizes;
        }
        if (productListConfig.displayProductsOnVariantLevel != null) {
          this.displayProductsOnVariantLevel = productListConfig.displayProductsOnVariantLevel;
        }
        if (productListConfig.fetchProductsExpanded != null) {
          this.fetchProductsExpanded = productListConfig.fetchProductsExpanded;
        }
        if (productListConfig.searchDisabled != null) {
          this.searchDisabled = productListConfig.searchDisabled;
        }
        if (productListConfig.assortmentBannerEnabled != null) {
          this.assortmentBannerEnabled = productListConfig.assortmentBannerEnabled;
        }
        if (productListConfig.keepFilterOpen != null) {
          this.keepFilterOpen = productListConfig.keepFilterOpen;
        }
        if (productListConfig.infiniteScroll != null) {
          this.infiniteScroll = productListConfig.infiniteScroll;
        }
        if (productListConfig.showProductListInArticlesView != null) {
          this.showProductListInArticlesView = productListConfig.showProductListInArticlesView;
        }
      })
    );
  }
}
